import React, { useState, useEffect } from "react"
import { updateNewPatient, getManageStaffDetailsById, getSmartSummaryData } from "../../core/services/api"
import { useLocation, useParams, useHistory } from "react-router"
import { IPatient } from "../../core/services/models/Patient"
import { useDispatch, useSelector } from "react-redux"
import PatientProfileCard from "../../components/PatientProfileCard"
import GeneticCounsellor from "../PatientClinicalView/components/GeneticCounsellor"
import Nutritionist from "../PatientClinicalView/components/Nutritionist"
import Physiotherapist from "../PatientClinicalView/components/Physiotherapist"
import Psychologist from "../PatientClinicalView/components/Psychologist"
import PatientDiagnosis from "../RMO/PatientDiagnosis"
import "./PatientClinicalView.scss"
import HomeCare from "./components/HomeCare"
import PermissionUtils from "../../core/store/utils/PermissionUtils"
import {
  getPatientDetail, getMedicalRecordByAppointmentId,
  getAppointmentById
} from "../../core/services/api"
import drawerAction from "../../core/store/actions/drawerAction"
import { MocUserRole } from "../../core/services/models/Enums"
import Toast from "components/Toast"
import moment from "moment"
import { styles } from "resources/styles/Styles"
import { useTheme } from "@emotion/react"
import MandatoryConsentForm from "components/MandatoryConsentForm/MandatoryConsentForm"
import { AppointmentStatus } from "core/services/models/AppointmentDetail"
import { getDisabledCenters } from "core/services/api/migrationService"

function PatientClinicalView() {
  const [selectedTab, setSelectedTab] = useState("RMO/Consultant")
  const [patientDetail, updatePatientDetail] = React.useState<IPatient>()
  const [recordDetails, setRecordDetails] = useState<any>()
  const [appointmentDetails, setAppointmentDetails] = useState<any>()
  const [displayToast, toggleDisplayToast] = useState<any>(false)
  const [isReadOnly, updateReadOnly] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [staffDetails, setStaffDetails] = useState<any>()
  //Smart Sumamary
  const [smartSummaryData, setSmartSummaryData] = useState<any>()
  //Staff Type
  const [staffType, setStaffType] = useState<any>("")
  //Survival and Account Status
  const [isActive, setActive] = useState<any>(false)
  const [isAlive, setAlive] = useState<any>(false)
  const [isFollowup, setFollowup] = useState<any>()
  const [patientDod, setPatientDod] = useState<Date>(new Date())

  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const userRole = useSelector((state: any) => state?.user?.role)
  const appointmentId = new URLSearchParams(location.search).get(
    "appointmentId"
  )
  const isStaffTypeView = new URLSearchParams(location.search).get(
    "staffTypeView"
  )
  const { patientId }: any = useParams()

  const theme = useTheme()
  const globalStyles = styles(theme)

  const tabSection: string[] = [
    "RMO/Consultant",
    "Genetic Counsellor",
    "Nutritionist",
    "Physiotherapist",
    "Psychologist"
  ]

  const initialTab: string = "RMO/Consultant"


  const getStaffType = (id: any) => {
    if (id) {
      getManageStaffDetailsById(id)
        .then((res: any) => {
          setStaffDetails(res)
          if (res?.primaryRole) {
            setStaffType(res?.primaryRole)
          }
        })
        .catch((err: any) => console.error(err?.message))
    }
  }

  function onPatientAccountChange(sts: any, textArea: any) {
    let temp: any = { ...patientDetail };
    temp["accountStatus"] = sts;
    temp["reasonForInactivatingAccount"] = textArea;
    temp["lostToFollowUp"] = false
    temp["accountInactivatedOn"] = moment().format("YYYY-MM-DD")
    updateNewPatient(temp).then((res) => {
      updatePatientDetail(res);
      setActive(false)
      toggleDisplayToast(null)
    })
  }

  function onPatientFollowupChange(textArea: any) {
    let temp: any = { ...patientDetail };
    temp["lostToFollowUp"] = true;
    temp["lostToFollowUpReason"] = textArea
    temp["followedUpDate"] = moment().format("YYYY-MM-DD")
    updateNewPatient(temp).then((res) => {
      updatePatientDetail(res);
      setFollowup(false)
      toggleDisplayToast(false)
    })
  }

  function onPatientStatusChange() {
    let temp: any = { ...patientDetail };
    temp["survivalStatus"] = isAlive ? "Deceased" : "Alive";
    temp["accountStatus"] = isAlive ? "inactive" : "active";
    temp["dod"] = isAlive ? moment().format("YYYY-MM-DD") : null;
    updateNewPatient(temp).then((res) => {
      updatePatientDetail(res);
      setAlive(!isAlive)
      toggleDisplayToast(false)
    })
  }

  function onPatientDODChange() {
    let temp: any = { ...patientDetail };
    temp["dod"] = !isAlive ? patientDod : null;
    updateNewPatient(temp).then((res) => {
      updatePatientDetail(res);
      setPatientDod(patientDod)
      toggleDisplayToast(false)
    })
  }

  const fetchSmartSummary = () => {
    getSmartSummaryData(patientId)
      .then((res: any) => {
        setSmartSummaryData(res?.data)
      }).catch((err: any) => {
        console.error(err?.message)
      })
  }

  useEffect(() => {
    getPatientDetail(patientId)
      .then((res: any) => {
        updatePatientDetail(res)
        setIsLoading(false)
      })
      .catch((err) => {
        console.error("err", err)
      })

    if (patientId) {
      fetchSmartSummary()
    }

    return () => {
      dispatch(drawerAction.setDrawerComponent(null))
    }
  }, [patientId])

  useEffect(() => {
    let drawerTimer: NodeJS.Timeout | undefined;
    const fetchData = async () => {
      try {
        if (appointmentId) {
          try {
            const appointmentDetails = await getAppointmentById(appointmentId);
            setAppointmentDetails(appointmentDetails);
            let isReadOnlyDrawer: any;
            if (appointmentDetails?.appointmentType === "IPD") {
              isReadOnlyDrawer =
                (userRole === MocUserRole.RMO ||
                  userRole === MocUserRole.CONSULTANT) &&
                  appointmentDetails?.isEditable &&
                  appointmentDetails?.arrivalTime
                  ? false
                  : true
            } else {
              isReadOnlyDrawer =
                ((userRole === MocUserRole.RMO ||
                  userRole === MocUserRole.CONSULTANT)) &&
                  appointmentDetails?.isEditable &&
                  appointmentDetails?.arrivalTime
                  ? false
                  : true
            }
            drawerTimer = setTimeout(() => {
              dispatch(
                drawerAction.setDrawerComponent({
                  name: "PatientDiagnosisDrawer",
                  data: {
                    patientId: appointmentDetails?.patientId,
                    appointmentDetails: appointmentDetails,
                    isReadOnly: isReadOnlyDrawer,
                  },
                })
              );
            }, 1000);

            let readOnly: boolean

            if (appointmentDetails?.appointmentType !== "IPD" && appointmentDetails?.appointmentType !== "HC") {
              setIsLoading(false)
            }

            if (
              (userRole === MocUserRole.RMO) ||
              (userRole === MocUserRole.CONSULTANT)
            ) {
              readOnly =
                userRole === MocUserRole.FRONT_DESK ||
                userRole === MocUserRole.NURSE ||
                !appointmentDetails?.isEditable ||
                !appointmentDetails?.arrivalTime
            } else {
              readOnly =
                userRole === MocUserRole.FRONT_DESK ||
                userRole === MocUserRole.SYSTEM_ADMIN ||
                userRole === MocUserRole.NURSE ||
                !appointmentDetails?.isEditable ||
                !appointmentDetails?.arrivalTime
            }
            updateReadOnly(
              appointmentDetails?.status === AppointmentStatus.CANCELLED ||
                appointmentDetails?.status === AppointmentStatus.NO_SHOW
                ? true
                : readOnly);

          } catch (appointmentDetailsError) {
            console.error("Error in fetching appointment details", appointmentDetailsError);
          }
          try {
            const medicalRecords = await getMedicalRecordByAppointmentId(appointmentId);
            setRecordDetails(medicalRecords);

          } catch (medicalRecordsError) {
            console.error("Error in fetching medical records", medicalRecordsError);
          }

        }
      } catch (error) {
        console.error("Error in fetchData", error);
      }
    };
    fetchData();
    return () => {
      clearTimeout(drawerTimer);
    };

  }, [appointmentId]);

  useEffect(() => {
    if (patientDetail && Object.keys(patientDetail)?.length > 0) {
      setActive(patientDetail?.accountStatus?.toLowerCase() === "active" ? true : false)
      setAlive(patientDetail?.survivalStatus?.toLowerCase() === "deceased" || patientDetail?.survivalStatus?.toLowerCase() === "dead" ? false : true)
      setFollowup(patientDetail?.lostToFollowUp ? true : false)
    }
  }, [patientDetail])

  useEffect(() => {
    if (appointmentDetails && patientDetail) {
      if (appointmentDetails?.consultantId) {
        getStaffType(appointmentDetails?.consultantId)
      } else if (patientDetail?.primaryConsultantId) {
        getStaffType(patientDetail?.primaryConsultantId)
      }
    }
  }, [appointmentDetails, patientDetail])

  useEffect(() => {
    const centerIds = new Set<string>()
    if (appointmentDetails?.centerId) {
      centerIds.add(appointmentDetails.centerId)
    }
    if (patientDetail?.centerId && patientDetail.centerId !== appointmentDetails?.centerId) {
      centerIds.add(patientDetail.centerId)
    }
    if (centerIds.size > 0) {
      getDisabledCenters()
        .then((response: any) => {
          const disabledCenters = response?.disabledCenters || []
          const matchedCenter = disabledCenters.find((center: any) =>
            centerIds.has(center.id)
          )
          if (matchedCenter) {
            toggleDisplayToast({
              text: `${matchedCenter.name} has been disabled. Modifications are not allowed.`,
              type: "error",
              onClickText: null,
              onCloseText: "Close",
            })
            updateReadOnly(true)
          }
        })
        .catch((error) => {
          console.error("Error fetching disabled centers:", error)
        })
    }
  }, [appointmentDetails, patientDetail])

  return (
    <div className="patient-clinical-container" id="patientDiagnosis">
      <div className="patient-clinical-inner-container">
        {isLoading ? (
          <div className="d-flex justify-content-center">
            <div
              className="spinner-border"
              style={{ width: "3rem", height: "3rem" }}
              role="status"
            ></div>
          </div>
        ) : (
          <MandatoryConsentForm
            appointmentDetails={appointmentDetails}
            appointmentId={appointmentId}
            staffDetails={staffDetails}
            patientDetail={patientDetail}
            smartSummaryData={smartSummaryData}
            closeModal={() => { }}
            showWarningOnly={true}
            readOnly={isReadOnly}
          >
            <div className="patient-smart-summary">
              <div className="d-flex align-items-center">
                <div
                  role="button"
                  onClick={() => {
                    history.goBack()
                  }}
                >
                  <img
                    src={"../../../../assets/images/back-icon.svg"}
                    alt="back button"
                    className="image-top-wrapper"
                  />
                </div>
                <div className="patient-heading">
                  Patient Diagnosis
                  {PermissionUtils.displayPatientName(
                    userRole,
                    patientDetail,
                    false,
                    "-",
                    "-"
                  )}
                  {patientDetail?.mocId}
                </div>
                <div>
                  {[
                    MocUserRole.SYSTEM_ADMIN,
                    MocUserRole.CENTER_ADMIN,
                    MocUserRole.FRONT_DESK,
                    MocUserRole.RMO,
                    MocUserRole.CONSULTANT
                  ].includes(userRole) && (
                      <div className="cursor-pointer" style={{ paddingLeft: "20px" }}>
                        <img
                          className={globalStyles.pointer}
                          src={"../../../assets/images/CRedit.svg"}
                          alt="edit"
                          width={24}
                          height={24}
                          onClick={() => history.push(`/editPatient/${patientDetail?.id}`)}

                        />
                      </div>
                    )}
                </div>
              </div>
              <div className="patient-profile" style={{ padding: "21px" }}>
                <PatientProfileCard
                  userRole={userRole}
                  patientDetail={patientDetail}
                  isActive={isActive}
                  isAlive={isAlive}
                  isFollowup={isFollowup}
                  isCalledFromDirectory={false}
                  setPatientDod={(date: any) => {
                    setPatientDod(date)
                    toggleDisplayToast({
                      text: `Are you sure you want to change the date of deceased to ${moment(date).format("DD-MM-YYYY")}?`,
                      type: "error",
                      onClickText: "Yes",
                      onCloseText: "Close",
                      dodCheck: true,
                    })
                  }}
                  setFollowup={(evt: any) => {
                    if (evt) {
                      toggleDisplayToast({
                        text: "Are you sure patient has lost to follow up?",
                        type: "error",
                        onClickText: "Yes",
                        onCloseText: "Close",
                        followupcheck: true,
                        textarea: "textarea"
                      })

                    }
                  }}
                  setActive={(evt: any) => {
                    if (!evt) {
                      toggleDisplayToast({
                        text: "Are You Sure You Want to mark the patient inactive?",
                        type: "error",
                        onClickText: "Yes",
                        onCloseText: "Close",
                        accountCheck: true,
                        textarea: "textarea"

                      })
                    } else {
                      setActive(evt)
                      onPatientAccountChange('active', "")
                    }
                  }}
                  setAlive={(evt: any) => {
                    toggleDisplayToast({
                      text: evt ?
                        "Are you sure you want to mark the patient alive?" :
                        "Are you sure you want to mark the patient deceased?",
                      type: evt ? "success" : "error",
                      onClickText: "Yes",
                      onCloseText: "Close",
                      statusCheck: true,
                    })
                  }}
                  isReadOnly={isReadOnly}
                />


              </div>
              {
                appointmentDetails?.appointmentType === "IPD" ? (
                  (
                    <div className="patient-diagnosis">
                      <div className="patient-smart-summary-container" >
                        <div className="tab-wrapper">

                          {tabSection.map((tabname: any) => (
                            <div
                              className={`tab ${selectedTab === tabname ? "active" : ""}`}
                              onClick={() => setSelectedTab(tabname)}>
                              {tabname}
                            </div>
                          ))}

                        </div>
                        <div className="content-wrapper">
                          {selectedTab === "RMO/Consultant" ? (
                            <PatientDiagnosis
                              patientInfo={patientDetail}
                              recordDetails={recordDetails}
                              appointmentDetails={appointmentDetails}
                              isStaffTypeView={isStaffTypeView}
                              isReadOnly={isReadOnly || (userRole !== MocUserRole?.RMO && userRole !== MocUserRole?.CONSULTANT)}
                              staffType={staffType}
                              smartSummaryData={smartSummaryData}
                              staffDetails={staffDetails}
                              fetchSmartSummary={fetchSmartSummary}
                            />
                          ) : selectedTab === "Genetic Counsellor" ? (
                            <MandatoryConsentForm
                              appointmentDetails={appointmentDetails}
                              appointmentId={appointmentId}
                              staffDetails={staffDetails}
                              patientDetail={patientDetail}
                              smartSummaryData={smartSummaryData}
                              closeModal={() => { setSelectedTab(initialTab) }}
                              showWarningOnly={false}
                              readOnly={isReadOnly}
                            >
                              <GeneticCounsellor
                                patientInfo={patientDetail}
                                recordDetails={recordDetails}
                                appointmentDetails={appointmentDetails}
                                isReadOnly={isReadOnly || userRole !== MocUserRole?.GENETIC_COUNSELLOR}
                                selectedIpdTab={selectedTab}
                                staffType={staffType}
                                smartSummaryDetails={smartSummaryData}
                                fetchSmartSummary={fetchSmartSummary}
                              />
                            </MandatoryConsentForm>
                          ) : selectedTab === "Nutritionist" ? (
                            <MandatoryConsentForm
                              appointmentDetails={appointmentDetails}
                              appointmentId={appointmentId}
                              staffDetails={staffDetails}
                              patientDetail={patientDetail}
                              smartSummaryData={smartSummaryData}
                              closeModal={() => { setSelectedTab(initialTab) }}
                              showWarningOnly={false}
                              readOnly={isReadOnly}
                            >
                              <Nutritionist
                                patientInfo={patientDetail}
                                recordDetails={recordDetails}
                                appointmentDetails={appointmentDetails}
                                isReadOnly={isReadOnly || userRole !== MocUserRole?.NUTRITIONIST}
                                selectedIpdTab={selectedTab}
                                staffType={staffType}
                                smartSummaryDetails={smartSummaryData}
                                fetchSmartSummary={fetchSmartSummary}
                              />
                            </MandatoryConsentForm>
                          ) : selectedTab === "Physiotherapist" ? (
                            <MandatoryConsentForm
                              appointmentDetails={appointmentDetails}
                              appointmentId={appointmentId}
                              staffDetails={staffDetails}
                              patientDetail={patientDetail}
                              smartSummaryData={smartSummaryData}
                              closeModal={() => { setSelectedTab(initialTab) }}
                              showWarningOnly={false}
                              readOnly={isReadOnly}
                            >
                              <Physiotherapist
                                patientInfo={patientDetail}
                                recordDetails={recordDetails}
                                appointmentDetails={appointmentDetails}
                                isReadOnly={isReadOnly || userRole !== MocUserRole?.PHYSIOTHERAPIST}
                                selectedIpdTab={selectedTab}
                                staffType={staffType}
                                smartSummaryDetails={smartSummaryData}
                                fetchSmartSummary={fetchSmartSummary}
                              />
                            </MandatoryConsentForm>
                          ) : (
                            <MandatoryConsentForm
                              appointmentDetails={appointmentDetails}
                              appointmentId={appointmentId}
                              staffDetails={staffDetails}
                              patientDetail={patientDetail}
                              smartSummaryData={smartSummaryData}
                              closeModal={() => { setSelectedTab(initialTab) }}
                              showWarningOnly={false}
                              readOnly={isReadOnly}
                            >
                              <Psychologist
                                patientInfo={patientDetail}
                                recordDetails={recordDetails}
                                appointmentDetails={appointmentDetails}
                                isReadOnly={isReadOnly || userRole !== MocUserRole?.PSYCHOLOGIST}
                                selectedIpdTab={selectedTab}
                                staffType={staffType}
                                smartSummaryDetails={smartSummaryData}
                                fetchSmartSummary={fetchSmartSummary}
                              />
                            </MandatoryConsentForm>
                          )}
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <>
                    {
                      (staffType === MocUserRole.GENETIC_COUNSELLOR ||
                        (appointmentDetails?.appointmentType === "IPD" &&
                          userRole === MocUserRole.GENETIC_COUNSELLOR)) ? (
                        <GeneticCounsellor
                          patientInfo={patientDetail}
                          recordDetails={recordDetails}
                          appointmentDetails={appointmentDetails}
                          isReadOnly={isReadOnly}
                          selectedIpdTab={selectedTab}
                          staffType={staffType}
                          smartSummaryDetails={smartSummaryData}
                          fetchSmartSummary={fetchSmartSummary}
                        />
                      ) :
                        (staffType === MocUserRole.NUTRITIONIST ||
                          (appointmentDetails?.appointmentType === "IPD" &&
                            userRole === MocUserRole.NUTRITIONIST)) ? (
                          <Nutritionist
                            patientInfo={patientDetail}
                            recordDetails={recordDetails}
                            appointmentDetails={appointmentDetails}
                            isReadOnly={isReadOnly}
                            selectedIpdTab={selectedTab}
                            staffType={staffType}
                            smartSummaryDetails={smartSummaryData}
                            fetchSmartSummary={fetchSmartSummary}
                          />
                        ) :
                          (staffType === MocUserRole.PHYSIOTHERAPIST ||
                            (appointmentDetails?.appointmentType === "IPD" &&
                              userRole === MocUserRole.PHYSIOTHERAPIST)) ? (
                            <Physiotherapist
                              patientInfo={patientDetail}
                              recordDetails={recordDetails}
                              appointmentDetails={appointmentDetails}
                              isReadOnly={isReadOnly}
                              selectedIpdTab={selectedTab}
                              staffType={staffType}
                              smartSummaryDetails={smartSummaryData}
                              fetchSmartSummary={fetchSmartSummary}
                            />
                          ) :
                            (staffType === MocUserRole.PSYCHOLOGIST ||
                              (appointmentDetails?.appointmentType === "IPD" &&
                                userRole === MocUserRole.PSYCHOLOGIST)) ? (
                              <Psychologist
                                patientInfo={patientDetail}
                                recordDetails={recordDetails}
                                appointmentDetails={appointmentDetails}
                                isReadOnly={isReadOnly}
                                selectedIpdTab={selectedTab}
                                staffType={staffType}
                                smartSummaryDetails={smartSummaryData}
                                fetchSmartSummary={fetchSmartSummary}
                              />
                            ) :
                              (
                                (
                                  staffType === MocUserRole.HOME_CARE_RMO ||
                                  staffType === MocUserRole.HOME_CARE_NURSE
                                ) ||
                                (
                                  userRole === MocUserRole.HOME_CARE_RMO ||
                                  userRole === MocUserRole.HOME_CARE_NURSE
                                )
                              ) ? (
                                <HomeCare
                                  patientInfo={patientDetail}
                                  recordDetails={recordDetails}
                                  appointmentDetails={appointmentDetails}
                                  isReadOnly={isReadOnly}
                                  staffType={staffType}
                                  smartSummaryDetails={smartSummaryData}
                                  fetchSmartSummary={fetchSmartSummary}
                                />
                              ) : (
                                <>
                                  <PatientDiagnosis
                                    patientInfo={patientDetail}
                                    recordDetails={recordDetails}
                                    appointmentDetails={appointmentDetails}
                                    isStaffTypeView={isStaffTypeView}
                                    isReadOnly={isReadOnly}
                                    staffType={staffType}
                                    smartSummaryData={smartSummaryData}
                                    staffDetails={staffDetails}
                                    fetchSmartSummary={fetchSmartSummary}
                                  />
                                </>
                              )
                    }
                  </>
                )
              }
            </div>
          </MandatoryConsentForm>
        )}
        {displayToast && <Toast
          textMessage={displayToast?.text}
          onClose={() => {
            toggleDisplayToast(false)
            if (displayToast?.navigateToCalendar) {
              history.push("/")
            }
          }}
          onCloseText="Close"
          onClickText={displayToast?.onClickText ? displayToast?.onClickText : null}
          textarea={displayToast?.textarea ? displayToast?.textarea : null}
          onClick={(textArea: any) => {
            return (
              displayToast?.followupcheck ? (
                onPatientFollowupChange(textArea))
                : displayToast?.statusCheck ? (
                  onPatientStatusChange()
                ) : displayToast?.accountCheck ? (
                  onPatientAccountChange("inactive", textArea)
                ) : displayToast?.dodCheck ? (
                  onPatientDODChange()
                ) : null
            )
          }}
          type={displayToast?.type} />}

      </div>
    </div>
  )
}

export default PatientClinicalView
